<template>
    <div
        v-if="(res.content_type == 2 && res.course_type !== 1) && !(res.content_type == 2 && res.enroll_status == 2) "
        class="detail-lianbao-mod"
    >
        <div v-if="res.sub_clazz_list && res.sub_clazz_list.length > 0" class="lianbao-parent">
            <div class="lianbao-parent__head">
                <template v-if="res.price_fen !== res.orig_price_fen">
                    <div
                        v-if="res.activity_info"
                        class="favourable"
                    >
                        原价{{fenToYuan(res.orig_price_fen)}},立减<span>¥{{fenToYuan(res.orig_price_fen) - fenToYuan(res.price_fen)}}</span> 仅需<span>¥{{fenToYuan(res.price_fen)}}</span>
                    </div>
                    <div
                        v-else
                        class="favourable"
                    >
                        非联报购买需￥{{fenToYuan(res.orig_price_fen)}},立减<span>¥{{fenToYuan(res.orig_price_fen) - fenToYuan(res.price_fen)}}</span> 仅需<span>¥{{fenToYuan(res.price_fen)}}</span>
                    </div>
                </template>
                <strong>包含课程</strong>
            </div>
            <div
                class="lianbao-parent__list"
                :class="{stretch: parentStretch}"
            >
                <div
                    v-for="(item, index) in res.sub_clazz_list"
                    @click="jumpCellClazz(item)"
                    :key="index"
                    class="lianbao-parent__item"
                    :class="{hide: index > maxLen - 1 }"
                >
                    <div class="around-course-card">
                        <div class="course-card-left">
                            <div class="course-classify">
                                <span v-if="item.season && res.display_detail!=1" class="season">{{item.season}}</span>
                                <span
                                    v-if="item.title_subject && res.biz_type !== 2"
                                    class="subject"
                                >
                                    {{item.title_subject}}
                                </span>
                                <span class="title ellipsis">{{item.title}}</span>
                            </div>
                            <div
                                v-if="item.first_lesson_begin_time &&  res.display_detail!=1"
                                class="course-time ellipsis"
                            >
                                时间：{{item.first_lesson_begin_time}}
                            </div>
                            <!-- 增加难度等级 -->
                            <difficultyLevel :card="item" />
                            <div v-if="res.display_detail!=1" class="lianbao-teacher clearfix">
                                <div
                                    v-for="(teacher, teachIndex) in item.teacher_list"
                                    :key="teachIndex"
                                    class="teacher"
                                >
                                    <div class="teacher__name ellipsis">{{teacher.teacher_name}}</div>
                                    <div class="teacher__text">{{teacher.teacherRole ||teacher.teacher_role || '主讲老师'}}</div>
                                </div>
                                <div v-if="item.counselor_name" class="teacher">
                                    <div class="teacher__name">{{item.counselor_name}}</div>
                                    <div class="teacher__text">{{item.counselor_role || '二讲老师'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="course-card-right">
                            <div class="course-price">
                                <div class="course-price__current"><i>¥</i>{{fenToYuan(displayOriginPrice ? item.initial_price_fen : item.price_fen)}}</div>
                                <div
                                    v-if="item.price_fen !== item.orig_price_fen"
                                    class="course-price__original"
                                >
                                    <i>¥</i>{{fenToYuan(item.orig_price_fen)}}
                                </div>
                            </div>
                            <div v-if="item.lesson_count && res.display_detail!=1" class="course-desc">共{{item.lesson_count}}课节</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="res.sub_clazz_list && res.sub_clazz_list.length > maxLen" class="lianbao-stretch">
                <span
                    class="more"
                    :class="{stretch: parentStretch}"
                    @click="onSetParentStretchHandler"
                >{{parentStretch ? '收起' : '点击查看更多课程'}}<i class="icon iconfont icon-unfold"></i></span>
            </div>
        </div>
        <div v-if="res.clazz_set_list && res.clazz_set_list.length > 0" class="lianbao-son">
            <div class="lianbao-son__head">
                同时报名以下课程 立减<span class="price">¥{{fenToYuan(Number(res.clazz_set_list[0].orig_price_fen) - Number(res.clazz_set_list[0].price_fen))}}</span> 仅需<span class="price">¥{{fenToYuan(res.clazz_set_list[0].price_fen)}}</span>
            </div>
            <div class="lianbao-son__list" :class="{stretch: sonStretch}">
                <div
                    v-for="(item, index) in res.clazz_set_list[0].sub_clazz_list"
                    :key="index"
                    class="around-course-card"
                    :class="{hide: index > maxLen - 1 }"
                >
                    <div class="course-card-left">
                        <div class="course-classify">
                            <span v-if="item.season && res.display_detail!=1" class="season">{{item.season}}</span>
                            <span
                                v-if="item.title_subject && res.biz_type !== 2"
                                class="subject"
                            >
                                {{item.title_subject}}
                            </span>
                            <span v-if="item.title" class="title ellipsis">{{item.title}}</span>
                        </div>
                        <!-- 增加难度等级 -->
                        <difficultyLevel :card="item" />
                        <div
                            v-if="item.first_lesson_begin_time &&  res.display_detail!=1"
                            class="course-time ellipsis"
                        >
                            时间: {{item.first_lesson_begin_time}}
                        </div>
                        <div class="course-teacher clearfix">
                            <div
                                v-for="(vitem, vitIndex) in item.teacher_list"
                                :key="vitIndex"
                                class="teacher clearfix"
                            >
                                <div class="teacher-left">
                                    <div class="teacher__icon">
                                        <webp-image :src="vitem.teacher_icon" width="80" height="80"/>
                                    </div>
                                </div>
                                <div class="teacher-right">
                                    <div class="teacher__name ellipsis">{{vitem.teacher_name}}</div>
                                    <div class="teacher__text">{{vitem.teacher_role || '主讲老师'}}</div>
                                </div>
                            </div>
                            <div v-if="item.counselor_name" class="teacher clearfix">
                                <div class="teacher-left">
                                    <div class="teacher__icon">
                                        <webp-image :src="item.counselor_icon" width="80" height="80"/>
                                    </div>
                                </div>
                                <div class="teacher-right">
                                    <div class="teacher__name ellipsis">{{item.counselor_name}}</div>
                                    <div class="teacher__text">{{item.counselor_role || '二讲老师'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="course-card-right">
                        <div class="course-price">
                            <div class="course-price__current"><i>¥</i>{{fenToYuan(item.price_fen)}}</div>
                            <div
                                v-if="item.price_fen !== item.orig_price_fen"
                                class="course-price__original"
                            >
                                <i>¥</i>{{fenToYuan(item.orig_price_fen)}}
                            </div>
                        </div>
                        <div v-if="item.lesson_count && res.display_detail!=1" class="course-desc">共{{item.lesson_count}}课节</div>
                    </div>
                </div>
            </div>
            <div v-if="res.clazz_set_list[0].sub_clazz_list.length > maxLen" class="lianbao-stretch">
                <span
                    class="more"
                    :class="{stretch: sonStretch}"
                    @click="onSetSonStretchHandler"
                >{{sonStretch ? '收起' : '点击查看更多课程'}}<i class="icon iconfont icon-unfold"></i></span>
            </div>
            <div class="lianbao-enroll clearfix">
                <div class="enroll">
                    <div class="enroll-btn" @click="onGotoLinkHander(res.clazz_set_list)">查看详情</div>
                    <div class="enroll-btn enroll-btn__up" @click="onApplyHandler(res.clazz_set_list)">立即报名</div>
                </div>
            </div>
        </div>
        <examPopup v-if="showExamPopup" :data="examdData" :res="res" />
    </div>
</template>
<script>
import api from '~/api';
import {mapState} from 'vuex';
import webpImage from '@business/components/common/webpImage';
import difficultyLevel from '@business/components/common/DifficultyLevel';
import examPopup from '@business/components/common/ExamPopup';
import qs from 'qs';
import config from '~/environment';

export default {
    name: 'DetailLianbaoCard',
    components: {
        difficultyLevel,
        examPopup,
        'webp-image': webpImage
    },
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            maxLen: 3,
            parentStretch: false,
            sonStretch: false,
            // 分层考试number
            examNumber: '',
            // 分层考试提示弹框建议
            clazzSuggestion: '',
            showExamPopup: false,
            examdData: {},
            query: '',
        };
    },
    computed: {
        ...mapState({
            token: state => state.token,
            p_client: state => state.p_client
        }),
        displayOriginPrice() {
            return !!this.res?.display_origin_price;
        }
    },
    methods: {
        jumpCellClazz(clazz) {
            const {activity_relink = 0} = this.res || {};
            if (!activity_relink) return;
            const {clazz_number = ''} = clazz || {};
            let query = this.query ? `?${this.query}` : '';
            if (this.p_client === 12) {
                window.open(`https:${config.env.pcUrl}/learn/${clazz_number}${query}`);
            }
            else {
                this.$router.push({path: `/learn/${clazz_number}${query}`});
            }
        },
        setExamdData() {
            this.examdData = {};
            this.showExamPopup = false;
        },
        onSetParentStretchHandler() {
            this.parentStretch = !this.parentStretch;
        },
        onSetSonStretchHandler() {
            this.sonStretch = !this.sonStretch;
        },
        onGotoLinkHander(payload) {
            if (this.p_client === 12) {
                window.open(`https:${config.env.pcUrl}/learn/${payload[0].activity_number}?course_type=${payload[0].course_type}&grade=${this.res.grade}`);
            }
            else {
                this.$router.push({
                    path: `/learn/${payload[0].activity_number}`,
                    query: {
                        course_type: payload[0].course_type,
                        grade: this.res.grade
                    }
                });
            }
        },
        onApplyHandler(payload) {
            const targetUrlQuery = {
                course_type: payload[0].course_type,
                grade: this.res.grade
            };
            const targetUrl = `/learn/${payload[0].activity_number}?${qs.stringify(targetUrlQuery)}`;
            this.$emit('buy-course', targetUrl);
            return;

            if (!this.token) {
                this.$store.commit('SET_ISSHOWLOGIN', true);
                return;
            }
            const {sub_clazz_list} = payload;
            const clazzNumberList = sub_clazz_list.map(item => item.clazz_number);
            // 判断是否是分层考试
            this.showExamPopup = false;
            const examParams = {
                clazzNumberList
            };
            this.$axios
                .$post(api.order.judgeIsNeedExamBeforePay, examParams, {headers: {'Content-Type': 'application/json'}})
                .then(res => {
                    const {code, data = {}} = res;
                    if (code === 0) {
                        this.examdData = data;
                        const {examNumber, hasMoreThanOneExam} = this.examdData;
                        if (hasMoreThanOneExam || (+examNumber !== 0 && !hasMoreThanOneExam)) {
                            this.showExamPopup = true;
                            return;
                        }
                        const params = {
                            productId: payload.activity_number,
                            courseType: payload.course_type,
                            checkNotPayOrder: true,
                            isFromH5: false
                        };
                        if (this.$route.query.counselor_id) {
                            params.counselorId = this.$route.query.counselor_id;
                        }
                        this.$axios.$get(api.order.canCreateOrder, {params}).then(res => {
                            if (res.status === 0) {
                                this.$router.push({
                                    path: `/apply/${params.productId}`,
                                    query: {
                                        courseType: params.courseType,
                                        grade: this.res.grade
                                    }
                                });
                            }
                        });
                    }
                });
        }
    },
    created() {
        let query = this.$route.fullPath.split('?')[1] || '';
        query = query.split('&').filter(item => !item.includes('course_type')).join('&');
        this.query = query;
    }
};
</script>
<style lang="less" scoped>
.lianbao-teacher {
    position: relative;
    overflow: hidden;

    .teacher {
        float: left;
        margin-right: 18px;
        width: 60px;

        &__name {
            font-size: 14px;
            color: #32404b;
            margin-bottom: 8px;
        }

        &__text {
            font-size: 12px;
            color: #818a92;
        }
    }
}

.lianbao-parent__list {
    &.stretch {
        .lianbao-parent__item {
            display: block;
        }
    }

    .lianbao-parent__item {
        cursor: pointer;
    }

    .course-card-right {
        height: 112px;
    }
}

.around-course-card {
    position: relative;
    padding: 30px 0;
    margin: 0 30px;
    overflow: hidden;

    &.hide {
        display: none;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #f5f5f5;
    }
}

.detail-lianbao-mod {
    margin-top: 20px;
    position: relative;
    width: 100%;

    .title {
        padding-left: 0 !important;
    }
}

.lianbao-parent {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px #ebebeb;

    &__head {
        padding: 30px;
        font-size: 20px;
        color: #32404b;
        border-bottom: 1px solid #f5f5f5;

        .favourable {
            float: right;

            span {
                font-size: 22px;
                color: #f3353a;
            }
        }

        strong {
            font-weight: 400;
        }
    }

    &__list {
        &.stretch {
            .lianbao-course__card {
                display: block;
            }
        }
    }

    &__item {
        position: relative;
        background-color: #fff;
        transition: all .2s linear;

        &:not(:last-child) {
            .lianbao-course__card {
                border-bottom: 1px solid #f5f5f5;
            }
        }

        &.hide {
            display: none;
        }
    }
}

.lianbao-stretch {
    position: relative;
    margin: 0 30px;
    text-align: center;
    border-top: 1px solid #f5f5f5;
    font-size: 16px;
    color: #f63232;
    margin-top: -1px;

    .more {
        display: inline-block;
        padding: 17px 0;
        cursor: pointer;

        i {
            display: inline-block;
            padding: 0 5px;
            color: #f63232;
            font-size: 20px;
            transform-origin: center center;
            transform: rotate(0deg);
            transition: all .3s ease-in;
        }

        &.stretch {
            i {
                transform: rotate(180deg);
            }
        }
    }
}

.lianbao-son__list {
    &.stretch {
        .around-course-card {
            display: block;
        }
    }
    .teacher__icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #f0f4fa;

        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
}

.lianbao-son {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px #ebebeb;

    &__item {
        padding: 35px 0;

        &.hide {
            display: none;
        }

        &:not(:last-child) {
            border-bottom: 1px solid #f5f5f5;
        }
    }

    &__list {
        position: relative;

        &.stretch {
            .lianbao-son__item {
                display: block;
            }
        }
    }

    &__head {
        padding: 28px 30px;
        font-size: 20px;
        color: #32404b;
        border-bottom: 1px solid #f5f5f5;

        span {
            font-size: 22px;
            color: #f3353a;
        }
    }

    .lianbao-enroll {
        position: relative;
        margin: 0 30px;
        padding: 20px 0;
        border-top: 1px solid #f5f5f5;

        .left_count {
            float: left;
            font-size: 16px;
            color: #818a92;
            line-height: 46px;

            span {
                font-size: 18px;
                color: #f63232;
            }
        }

        .enroll {
            float: right;
            font-size: 0;

            &-btn {
                display: inline-block;
                border-radius: 4px;
                border: solid 1px #f63232;
                width: 128px;
                height: 44px;
                text-align: center;
                line-height: 44px;
                font-size: 20px;
                cursor: pointer;
                color: #f63232;
                margin-left: 20px;
                overflow: hidden;

                &__up {
                    background-color: #f63232;
                    color: #fff;
                }
            }
        }
    }
}
</style>
